<itl-input-button-template
  [control]="control"
  [hasErrors]="control ? control.invalid : false"
  [title]="title"
  [disabled]="disabled"
  [icon]="icon"
  [required]="required"
  [placeholder]="placeholder"
  [value]="selectedItem?.displayText"
  (buttonPressed)="openSearchView()"
  [description]="description"
>
  <div
    class="deleteButton"
    (click)="removeSelected($event)"
    *ngIf="selectedItem?.displayText && !disabled && showDeleteButton"
  >
    <ion-icon name="alberta-delete"></ion-icon>
  </div>
  <div class="searchIcon" *ngIf="!selectedItem?.displayText">
    <ion-icon name="alberta-lens"></ion-icon>
  </div>
</itl-input-button-template>
